import './style.scss'

export default function Loader(){
    return (
        <div className="scm-loader-container">
            <div className="scm-loader"></div>
        </div>
    )
}
